import router from '@/router'
import { readStoredValue } from '@/auth/session'
import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => Promise.reject(error),
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  getToken() {
    return readStoredValue(this.jwtConfig.storageTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  async logout({ revoke = false } = {}) {
    let revocationFailed = false
    if (revoke && this.getToken()) {
      try { await this.axiosIns.post('auth/logout', {}, { timeout: 10000, skipUnauthorizedHandler: true }) } catch (error) { revocationFailed = true }
    }
    const keys = [this.jwtConfig.storageTokenKeyName, this.jwtConfig.storageRefreshTokenKeyName, 'userData']
    keys.forEach(key => {
      try {
        localStorage.removeItem(key)
      } catch (error) {
        // Login navigation must remain available when browser storage is blocked.
      }
    })

    // Redirect to login page
    router.push({ name: 'auth-login', query: revocationFailed ? { logout: 'revocation-unconfirmed' } : {} })
  }
}
